module.exports = __webpack_public_path__ + "static/media/t06ru.ac5d6b04.pdf";